import { ESectionTrackStatus } from '@constants';
import { useQuery } from '@tanstack/react-query';
import { create as createZustand } from 'zustand';

import { sdk } from '@/services';

interface ITrackingFilterStore {
  selectedSubscriptionIds: string[];
  setSelectedSubscriptionIds: (ids: string[]) => void;
}

export const useTrackingFilterStore = createZustand<ITrackingFilterStore>(set => ({
  selectedSubscriptionIds: [],
  setSelectedSubscriptionIds: (ids: string[]) => set({ selectedSubscriptionIds: ids })
}));

const SubscriptionService = sdk.getService('SubscriptionService');

export const useSubscriptionsTrackingStats = () => {
  const { selectedSubscriptionIds, setSelectedSubscriptionIds } = useTrackingFilterStore();

  const { data, isLoading } = useQuery({
    queryKey: ['subscriptions-tracking-stats', selectedSubscriptionIds],
    queryFn: () => SubscriptionService.getSubscriptionsTrackingStats(selectedSubscriptionIds),
    select: (incomingData?: Record<string, number> | null) => {
      return {
        [ESectionTrackStatus.KNOWN]: incomingData?.['KNOWN'] ?? 0,
        [ESectionTrackStatus.REVISED]: incomingData?.['REVISED'] ?? 0,
        [ESectionTrackStatus.SUMMARISED]: incomingData?.['SUMMARISED'] ?? 0,
        [ESectionTrackStatus.SEEN]: incomingData?.['SEEN'] ?? 0,
        [ESectionTrackStatus.NOT_STARTED]: incomingData?.['NOT_STARTED'] ?? 0,
        [ESectionTrackStatus.STUDIED]: incomingData?.['STUDIED'] ?? 0
      };
    }
  });

  return {
    subscriptionsTrackingStats: data,
    isLoading,
    selectedSubscriptionIds,
    setSelectedSubscriptionIds
  };
};
